import type { FC } from 'react';
import { Text } from '@chakra-ui/react';
import { Grid } from '@anywayseo/tools';
import { alternativeCasinos, type Locale, type Localized } from 'content/data';

import { Modal, AlternativeCasinoCard } from './components';

const TitleMap: Localized<string> = {
  de: 'Ups! Ein kleines Problem ... 😔 Keine Sorge, wir haben eine Lösung!',
  en: "Oops! Something went wrong … 😔 But we've got you covered!",
};

const DescriptionMap: Localized<string> = {
  de: 'Leider ist die Registrierung vorübergehend nicht verfügbar, 💡 ABER – schauen Sie sich unten diese großartigen Angebote unserer Partner an! Die Boni sind sogar noch besser! 🎁',
  en: 'Registration is temporarily unavailable 💡 — but check out these great partner offers below. The bonuses are even bigger! 🎁',
};

type CasinoAlternativesModalProps = {
  locale: Locale;
  isOpen: boolean;
  onClose: VoidFunction;
};

export const CtaModal: FC<CasinoAlternativesModalProps> = ({ isOpen, onClose, locale }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Text as='h3' fontSize={24} mb={2}>
        {TitleMap[locale]}
      </Text>
      <Text mb={4}>{DescriptionMap[locale]}</Text>
      <Grid
        columns={{ sm: 1, md: 3 }}
        gap={4}
        items={alternativeCasinos[locale]}
        render={(casino) => <AlternativeCasinoCard key={casino.id} {...casino} />}
      />
    </Modal>
  );
};
